"use strict";

/*
 * SoleThreads wishlist: "Add all to cart".
 * Glozin's wishlist stores product IDs only (no chosen size), so only rows that
 * render with data-direct-add="true" (single variant, in stock) are added.
 * Rows that need a size are skipped and reported in the status message.
 * The cart drawer update mirrors Glozin's <product-form> (assets/theme.js).
 */
if (!customElements.get("st-wishlist-add-all")) {
  customElements.define(
    "st-wishlist-add-all",
    class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.button = this.querySelector("button");
        this.status = this.querySelector("[role='status']");
        if (this.button) {
          this.button.addEventListener("click", this.onClick.bind(this));
        }
      }

      message(name, count) {
        const key = "message" + name.charAt(0).toUpperCase() + name.slice(1);
        return (this.dataset[key] || "").replace("[count]", count);
      }

      setStatus(text) {
        if (this.status) this.status.textContent = text;
      }

      getRows() {
        const root = this.closest(".wishlist-page-main") || document;
        return Array.from(root.querySelectorAll(".st-wl-row"));
      }

      async onClick() {
        if (this.button.classList.contains("loading")) return;

        const rows = this.getRows();
        const items = rows
          .filter((row) => row.dataset.directAdd === "true" && row.dataset.variantId)
          .map((row) => ({ id: Number(row.dataset.variantId), quantity: 1 }));
        const skipped = rows.filter(
          (row) => row.dataset.directAdd !== "true" && row.dataset.available === "true"
        ).length;

        if (items.length === 0) {
          this.setStatus(this.message("none", skipped));
          return;
        }

        const cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        const body = { items };
        if (cart && typeof cart.getSectionsToRender === "function") {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
        }

        this.setStatus("");
        this.button.classList.add("loading");
        this.button.setAttribute("aria-busy", "true");

        try {
          const config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          config.body = JSON.stringify(body);
          const response = await fetch(`${window.routes.cart_add_url}`, config);
          const data = await response.json();

          if (data.status) {
            this.setStatus(data.description || data.message || this.message("error", 0));
            return;
          }
          if (!cart) {
            window.location = window.routes.cart_url;
            return;
          }

          let text = this.message("added", items.length);
          if (skipped > 0) text += " " + this.message("skipped", skipped);
          this.setStatus(text);
          this.updateCart(cart, data);
        } catch (error) {
          console.error(error);
          this.setStatus(this.message("error", 0));
        } finally {
          this.button.classList.remove("loading");
          this.button.removeAttribute("aria-busy");
        }
      }

      updateCart(cart, data) {
        fetch("/cart.json")
          .then((res) => res.json())
          .then((cartData) => {
            if (cartData.item_count == undefined) return;
            document.querySelectorAll(".cart-count").forEach((el) => {
              if (el.classList.contains("cart-count-drawer")) {
                el.innerHTML = `(${cartData.item_count})`;
              } else {
                el.innerHTML = cartData.item_count > 100 ? "~" : cartData.item_count;
              }
            });
            const headerTotal = document.querySelector("header-total-price");
            if (headerTotal) headerTotal.updateTotal(cartData);
            const freeShip = document.querySelector("free-ship-progress-bar");
            if (freeShip) freeShip.init(cartData.items_subtotal_price);
          })
          .catch((error) => console.error(error));

        if (data.sections) {
          cart.getSectionsToRender().forEach((section) => {
            const elementToReplace = document.getElementById(section.id);
            const markup = data.sections[section.id];
            if (!elementToReplace || !markup) return;
            const html = new DOMParser().parseFromString(markup, "text/html");
            const form = html.querySelector("#minicart-form");
            if (form) elementToReplace.innerHTML = form.innerHTML;
          });
        }
        if (typeof cart.cartAction === "function") cart.cartAction();
        cart.classList.remove("is-empty");

        if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: "wishlist-add-all", cartData: data });
        }
        setTimeout(() => {
          if (typeof showMinicartAddSuccessMessage === "function") {
            showMinicartAddSuccessMessage(cart);
          }
          if (typeof cart.open === "function") cart.open();
        }, 300);
      }
    }
  );
}
